import { getOnlinePay } from "utils/api";

export const queryList = async (params) => {
  return await getOnlinePay("/transaction/list", {
    sort: "time,desc",
    ...params,
  });
};

export const exportCsv = async (params) => {
  return await getOnlinePay("/transaction/list", {
    output: "csv",
    ...params,
  });
};
